import React, { useEffect, useState } from 'react';
import {
  Grid,
  Card,
  CardContent,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Pagination,
  TableContainer,
  Paper,
  Typography,
  Tabs,
  Tab,
} from '@mui/material';
import { saveAs } from 'file-saver';
import { Navigate, useNavigate } from 'react-router-dom';
import '../../styles/Service.scss';
import '../../styles/App.scss';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  ADD_SERVICE,
  EDIT_SERVICE,
  VIEW_SERVICE,
} from '../../component/common/Routes/AppRoutes';
import SearchAndButtonTab from '../../component/ui/SearchAndButtonTab';
import { formatDateWithAmPm, getStatusClass } from '../../Style';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchAllServiceRequest,
  resetServiceDetails,
  serviceDeleteRequest,
  serviceViewAllRequest,
} from '../../redux/Service/ServiceAction';
import { toast, ToastContainer } from 'react-toastify';
import CustomButton from '../../component/ui/FormFields/Button';
import nodata from '../../assets/nodata.jpg';
import Loading from '../../component/ui/Loading';

const ServiceList = () => {
  const user = useSelector((state) => state.auth.user);
  const permissions = user?.permissions;

  const [searchQuery, setSearchQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [selectedService, setSelectedService] = useState('service');
  const [page, setPage] = useState(1);
  const [searchColumn, setSearchColumn] = useState('id');
  const [selectedTab, setSelectedTab] = useState(0);
  const rowsPerPage = 5;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetServiceDetails());
  }, []);
  const serviceDetail = useSelector(
    (state) => state.services?.ServiceDetails || {}
  );

  const viewListLoading = serviceDetail?.loading;

  const DeleteServiceDetails = useSelector(
    (state) => state.services?.Service || {}
  );
  const deleteLoading = DeleteServiceDetails?.deleteLoading;
  const serviceDetails = serviceDetail?.data || [];

  const deleteServiceSuccess = DeleteServiceDetails?.success;
  const totalSize = serviceDetail?.totalRecords;

  useEffect(() => {
    dispatch(fetchAllServiceRequest());
  }, [dispatch, page, totalSize]);

  useEffect(() => {
    if (deleteServiceSuccess) {
      toast.success('Service Deleted Successfully', {
        position: 'top-center',
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: false,

        onClose: () => {
          dispatch(resetServiceDetails());
          dispatch(fetchAllServiceRequest());
        },
      });
    }
  }, [deleteServiceSuccess]);

  const handleClosePopup = () => {
    setSelectedService(null);
    setOpen(false);
  };

  const handleConfirmDelete = async (deleteValue) => {
    await dispatch(serviceDeleteRequest(deleteValue.id));

    handleClosePopup();
  };

  const handleExport = () => {
    const csvHeaders = [
      'Service Name,Service Type,Airport Type,Departure Rate,Arrival Rate,Transit Rate,Status,Approval Status,Created Date',
    ];

    const csvRows = serviceDetails.map((service) => {
      // Function to properly escape CSV fields
      const escapeCsvField = (field) => {
        if (field === null || field === undefined) return '""';
        const stringField = String(field || '-');
        // If the field contains commas, quotes, or newlines, wrap it in quotes and escape any quotes
        if (
          stringField.includes(',') ||
          stringField.includes('"') ||
          stringField.includes('\n')
        ) {
          return `"${stringField.replace(/"/g, '""')}"`;
        }
        return stringField;
      };

      const status = service.status == 1 ? 'Active' : 'Inactive';
      const approvalStatus =
        service.approoved_status === 2
          ? 'Pending'
          : service.approoved_status === 1
          ? 'Approved'
          : 'Rejected';

      return [
        escapeCsvField(service.services),
        escapeCsvField(service.type_of_service?.toUpperCase()),
        escapeCsvField(service.type_of_name?.toUpperCase()),
        escapeCsvField(service.departure?.slice(0, 8)),
        escapeCsvField(service.arrival?.slice(0, 8)),
        escapeCsvField(service.transit?.slice(0, 8)),
        escapeCsvField(status),
        escapeCsvField(approvalStatus),
        escapeCsvField(formatDateWithAmPm(service.created_at)),
      ].join(',');
    });

    const csvContent = [csvHeaders, ...csvRows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'services.csv');
  };
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  const handleOpenDialog = (service) => {
    setSelectedService(service);
    setOpen(true);
  };
  const handleCloseDialog = () => {
    setSelectedService(null);
    setOpen(false);
  };
  const handlePageChange = (event, newPage) => setPage(newPage);
  const navigate = useNavigate();
  const renderActions = (service) => (
    <Box className='button-list'>
      {(permissions?.services?.view || user?.user_type === 1) && (
        <Button
          variant='outlined'
          size='small'
          className='view-user-button'
          onClick={() =>
            navigate(`${VIEW_SERVICE.replace(':serviceId', service.id)}`)
          }
        >
          View
        </Button>
      )}
      {(permissions?.services?.edit || user?.user_type === 1) && (
        <Button
          variant='outlined'
          className='edit-user-button'
          size='small'
          onClick={() =>
            navigate(`${EDIT_SERVICE.replace(':serviceId', service.id)}`)
          }
        >
          Edit
        </Button>
      )}
      {(permissions?.services?.delete || user?.user_type === 1) && (
        <CustomButton
          variant='contained'
          className='delete-user-button'
          type='button'
          text={'DELETE'}
          size='small'
          onClick={() => handleOpenDialog(service)}
        />
      )}
    </Box>
  );

  const approved_service = serviceDetails.filter(
    (value) => value.approoved_status === 1
  );
  const pending_service = serviceDetails.filter(
    (value) => value.approoved_status === 2
  );
  const rejected_service = serviceDetails.filter(
    (value) => value.approoved_status === 3
  );

  useEffect(() => {
    if (selectedTab === 0 && pending_service.length === 0) {
      setSelectedTab(approved_service.length > 0 ? 1 : 2);
    }
  }, [
    pending_service.length,
    approved_service.length,
    rejected_service.length,
  ]);

  const filteredServices = serviceDetails.filter((service) => {
    const searchCondition = searchQuery
      ? (service[searchColumn] || '')
          .toString()
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      : true;

    const approvalStatusCondition =
      selectedTab === 0
        ? service.approoved_status === 2 // Pending
        : selectedTab === 1
        ? service.approoved_status === 1 // Approved
        : selectedTab === 2
        ? service.approoved_status === 3 // Rejected
        : true;

    return searchCondition && approvalStatusCondition;
  });

  const paginatedService = filteredServices.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );
  const tableHeaders = [
    'SERVICE Name',
    'SERVICE TYPE',
    'ARRIVAL/DEPARTURE',
    // "DEPARTURE",
    // "ARRIVAL",
    'STATUS',
    'APPROVED STATUS',
    'CREATED DATE',
  ];

  const columns = [
    { value: 'services', label: 'SERVICE NAME' },
    { value: 'type_of_service', label: 'SERVICE TYPE' },
    { value: 'type_of_name', label: 'ARRIVAL/DEPARTURE' },
    // { value: 'status', label: 'SERVICE STATUS' },
    // { value: "created_at", label: "CREATED DATE" }
  ];

  if (viewListLoading) {
    return <Loading text='Loading service details...' />;
  }

  return (
    <>
      <ToastContainer />

      <Box className='container'>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <SearchAndButtonTab
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                  searchColumn={searchColumn}
                  setSearchColumn={setSearchColumn}
                  columns={columns}
                  handleExport={handleExport}
                  title='Services'
                  routeName={ADD_SERVICE}
                  permissions={permissions}
                  user={user}
                  type='services'
                />
                <Tabs
                  value={selectedTab}
                  onChange={handleTabChange}
                  aria-label='Approval Status Tabs'
                  sx={{ marginBottom: 2 }}
                >
                  <Tab label='Pending' />
                  <Tab label='Approved' />
                  <Tab label='Rejected' />
                </Tabs>

                <TableContainer component={Paper}>
                  <PerfectScrollbar>
                    {paginatedService.length > 0 ? (
                      <Table>
                        <TableHead>
                          <TableRow>
                            {tableHeaders.map((column) => (
                              <TableCell key={column}>{column}</TableCell>
                            ))}
                            <TableCell>Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {paginatedService?.map((service) => (
                            <TableRow key={service.service_id}>
                              <TableCell>{service.services}</TableCell>
                              <TableCell>
                                {service.type_of_service?.toUpperCase()}
                              </TableCell>
                              <TableCell>
                                {service.type_of_name?.toUpperCase()}
                              </TableCell>
                              {/* <TableCell>
                                {service.departure?.slice(0, 8)}
                              </TableCell>
                              <TableCell>
                                {service.arrival?.slice(0, 8)}
                              </TableCell> */}

                              <TableCell>
                                <span
                                  className={`badge ${getStatusClass(
                                    service.status == 1 ? 'Active' : 'Inactive'
                                  )}`}
                                >
                                  {service.status == 1 ? 'Active' : 'Inactive'}
                                </span>
                              </TableCell>
                              <TableCell>
                                <span
                                  className={`badge ${getStatusClass(
                                    service.approoved_status === 2
                                      ? 'Pending'
                                      : service.approoved_status === 1
                                      ? 'Approved'
                                      : 'Rejected'
                                  )}`}
                                >
                                  {service.approoved_status === 2
                                    ? 'Pending'
                                    : service.approoved_status === 1
                                    ? 'Approved'
                                    : 'Rejected'}
                                </span>
                              </TableCell>
                              <TableCell>
                                {formatDateWithAmPm(service.created_at)}
                              </TableCell>
                              <TableCell>{renderActions(service)}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: '100%',
                        }}
                      >
                        {paginatedService.length === 0 && (
                          <img
                            src={nodata}
                            alt='nodata'
                            style={{ maxWidth: '300px', maxHeight: '300px' }}
                          />
                        )}
                      </div>
                    )}
                  </PerfectScrollbar>
                </TableContainer>
                <Box className='button-box'>
                  {filteredServices.length > 0 && (
                    <Pagination
                      count={Math.ceil(filteredServices.length / rowsPerPage)}
                      page={page}
                      onChange={handlePageChange}
                      color='primary'
                    />
                  )}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Dialog open={open} onClose={handleCloseDialog}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete{' '}
              <strong>{selectedService?.services}</strong>?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button className='grey-button' onClick={handleCloseDialog}>
              Cancel
            </Button>
            <CustomButton
              variant='contained'
              className='orange-button'
              type='button'
              loading={deleteLoading}
              text={'DELETE'}
              onClick={() => handleConfirmDelete(selectedService)}
            />
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};
export default ServiceList;
